export default __webpack_public_path__ + "4ea5afbf5d3615624b7bc9f568df483d.png";